import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import PublicStatus from "@/pages/PublicStatus";
import Dashboard from "@/pages/Dashboard";
import Beneficiaries from "@/pages/Beneficiaries";
import BeneficiaryDetail from "@/pages/BeneficiaryDetail";
import BeneficiaryForm from "@/pages/BeneficiaryForm";
import AttendanceSampleForm from "@/pages/AttendanceSampleForm";
import Reports from "@/pages/Reports";
import ImportPage from "@/pages/ImportPage";
import InstallmentImport from "@/pages/InstallmentImport";
import Users from "@/pages/Users";
import AuditLogs from "@/pages/AuditLogs";
import Settings from "@/pages/Settings";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="grid h-screen place-items-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

const routes = [
  ["/", <Dashboard />],
  ["/beneficiaries", <Beneficiaries />],
  ["/beneficiaries/new", <BeneficiaryForm />],
  ["/beneficiaries/:bid", <BeneficiaryDetail />],
  ["/beneficiaries/:bid/edit", <BeneficiaryForm />],
  ["/attendance-form", <AttendanceSampleForm />],
  ["/reports", <Reports />],
  ["/import", <ImportPage />],
  ["/installment-import", <InstallmentImport />],
  ["/users", <Users />],
  ["/audit-logs", <AuditLogs />],
  ["/settings", <Settings />],
];

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/status" element={<PublicStatus />} />
          {routes.map(([path, el]) => (
            <Route key={path} path={path} element={<Protected>{el}</Protected>} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
